// ** React Imports
import { Fragment, useState } from "react";

// ** MUI Components
import {
  IconButton,
  Button,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import FormLabel from "@mui/material/FormLabel";
import Grid from "@mui/material/Grid";

// Custom Component Imports
import CustomTextField from '../../../components/mui/text-field';

// ** Icon Imports
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import CloseIcon from "@mui/icons-material/Close";
import StarIcon from "@mui/icons-material/Star";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import Icon from '../../../components/icon'
import InfoIcon from '@mui/icons-material/Info';

const DeactivateCustomer = ({
    open,
    handleClose,
}) => {

    return (
        <Dialog
        fullWidth={true}
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
            <Grid container spacing={5}>
                <Grid item xs={12}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Typography variant="h4" fontWeight='bold'>
                            Deactivate Customer Portal?
                        </Typography>
                        <Typography variant="body" color='text.secondary'>
                            Are you sure you wish to deactivate the customer portal for Danial Anderson? 
                        </Typography>
                    </Box>
                </Grid>
                <Grid item xs={12} mb={4}>
                    <Box
                        sx={{
                            backgroundColor: '#EBF1FF',
                            p: 4,
                            borderRadius: 2
                        }}
                    >
                        <Box sx={{display: 'flex', mb: 2, gap: 2}}>
                            <InfoIcon sx={{color: '#335CFF'}} />
                            <Typography variant='h5' fontWeight='bold'>Important Note</Typography>
                        </Box>
                        <Typography variant="body" color='text.secondary'>
                            Deactivating the portal will stop customer access to self-service features like viewing history and tracking status. They will be set to inactive but will still receive emails.
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions
          sx={{ 
                display: "flex", 
                justifyContent: "flex-end", 
                padding: '20px 24px !important', 
                boxShadow: `0px -4px 8px rgb(0, 0, 0, 0.1)`, 
                zIndex: 1 
            }}
          className="dialog-actions-dense"
        >
          <Box>
            <Button
              variant="contained"
              color="info"
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
          <Box>
            <Button
              variant="contained"
              color="error"
              onClick={handleClose}
            >
                Confirm Deactivation
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    )
}

export default DeactivateCustomer